export default "<div class='user-form-container'>\n  <app-user-form [uuid]=\"uuid\"></app-user-form>\n</div>\n\n"